import { Component, Element, h, Host, Prop } from '@stencil/core';
import { BREAKPOINTS } from '../../models/breakpoints.types';
import {
  ASPECT_RATIOS,
  AspectRatioScreenLg,
  AspectRatioScreenMd,
  AspectRatioScreenSm,
  LOADING_TYPES,
  LoadingType,
  PARENT_COMPONENT,
  ParentComponent,
} from './models/image.types';

@Component({
  tag: 'wink-img',
  styleUrl: 'styles/image.default.scss',
  shadow: true,
})
export class Image {
  @Element() host!: HTMLWinkImgElement;

  @Prop({ reflect: true }) srcDesktop = '';
  @Prop() srcTablet?: string;
  @Prop() srcMobile?: string;
  @Prop() alt?: string;
  @Prop() loading: LoadingType = LOADING_TYPES.lazy;
  @Prop() isFullWidth = false;
  @Prop() hasBgCover = false;
  @Prop() aspectRatioScreenLg?: AspectRatioScreenLg;
  @Prop() aspectRatioScreenMd?: AspectRatioScreenMd;
  @Prop() aspectRatioScreenSm?: AspectRatioScreenSm;
  @Prop() parentComponent?: ParentComponent = PARENT_COMPONENT.none;

  private getClasses(): { [key: string]: boolean } {
    return {
      'full-width': this.isFullWidth,
      'background-cover': this.hasBgCover,
      [`aspect-ratio--lg-${this.aspectRatioScreenLg}`]: !!this.aspectRatioScreenLg && this.aspectRatioScreenLg !== ASPECT_RATIOS.none,
      [`aspect-ratio--md-${this.aspectRatioScreenMd}`]: !!this.aspectRatioScreenMd && this.aspectRatioScreenMd !== ASPECT_RATIOS.none,
      [`aspect-ratio--sm-${this.aspectRatioScreenSm}`]: !!this.aspectRatioScreenSm && this.aspectRatioScreenSm !== ASPECT_RATIOS.none,
      'aspect-ratio':
        (!!this.aspectRatioScreenLg && this.aspectRatioScreenLg !== ASPECT_RATIOS.none) ||
        (!!this.aspectRatioScreenMd && this.aspectRatioScreenMd !== ASPECT_RATIOS.none) ||
        (!!this.aspectRatioScreenSm && this.aspectRatioScreenSm !== ASPECT_RATIOS.none),
      [`wink-${this.parentComponent}`]: !!this.parentComponent && this.parentComponent !== PARENT_COMPONENT.none,
    };
  }

  render() {
    const isDecorative = !this.alt || this.alt.trim() === '';
    const altText = isDecorative ? '' : this.alt;

    if (!this.alt) {
      console.warn('wink-img: alt attribute is missing. Provide a descriptive alt text for accessibility.');
    }

    return (
      <Host>
        {this.srcDesktop ? (
          <picture class={this.getClasses()}>
            {this.srcMobile && <source srcSet={this.srcMobile} media={BREAKPOINTS.mobile} />}
            {this.srcTablet && <source srcSet={this.srcTablet} media={BREAKPOINTS.tablet} />}
            <img class={this.isFullWidth ? 'full-width' : ''} src={this.srcDesktop} alt={altText} loading={this.loading} />
          </picture>
        ) : (
          <p>Please set src </p>
        )}
      </Host>
    );
  }
}
